import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../../../../components/icon/icon.component';
import { LoadingAreaComponent } from '../../../../components/loading-area/loading-area.component';
import { EpiService } from '../../../../services/epi/epi.service';
import { AppData } from '../../../../types/translations.types';

@Component({
	selector: 'cramo-confirm-disable-jobsite',
	templateUrl: './confirm-disable-jobsite.component.html',
	imports: [LoadingAreaComponent, IconComponent],
})
export class ConfirmDisableJobsiteComponent {
	public appData: AppData;

	@Input() public disablingJobsite: boolean;

	@Output() public byDisableTheJobsite: EventEmitter<null> = new EventEmitter();
	@Output() public closePanel: EventEmitter<boolean> = new EventEmitter();

	constructor(private epiService: EpiService) {
		this.appData = this.epiService.appData;
	}

	public disableTheJosite() {
		this.closePanel.emit(true);
		this.byDisableTheJobsite.emit();
	}
}
